import React from "react";
import MuiIcon from "@mui/material/Icon";
import SvgIcon from "@mui/material/SvgIcon";
const Icon = ({ children, style, ...props }) => (
  <MuiIcon
    {...props}
    style={{
      ...style,
      display: "flex",
      backgroundColor: "transparent",
      justifyContent: "center",
      alignItems: "center",
      height: "auto",
    }}
    sx={{
      maxWidth: style?.maxWidth,
      width: style?.width,
      height: " auto",

      "& svg *": {
        fill: style?.color,
        stroke: style?.color,
      },
    }}
  >
    {children}
  </MuiIcon>
);

export default Icon;
